import script from "./editModal.vue?vue&type=script&setup=true&lang=js"
export * from "./editModal.vue?vue&type=script&setup=true&lang=js"

import "./editModal.vue?vue&type=style&index=0&id=43cab4e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43cab4e5"]])

export default __exports__